import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scoreToColor, scoreToGrade } from "@/lib/scoring";

export const ScoreGauge = ({ score = 0, size = 240, label = "Composite Score", showGrade = true, testId = "score-gauge" }) => {
  const r = (size - 28) / 2;
  const circ = 2 * Math.PI * r;
  const safeScore = Math.max(0, Math.min(100, score || 0));
  const offset = circ - (safeScore / 100) * circ;
  const color = scoreToColor(safeScore);
  const grade = scoreToGrade(safeScore);

  const [displayed, setDisplayed] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 900;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplayed(Math.round(safeScore * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [safeScore]);

  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--rg-border)" strokeWidth="14" />
          <motion.circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth="14"
            strokeLinecap="round"
            strokeDasharray={circ}
            initial={{ strokeDashoffset: circ }}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 1.0, ease: "easeOut" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-heading font-extrabold text-[var(--rg-text-strong)]" style={{ fontSize: size * 0.28, lineHeight: 1 }}>{displayed}</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--rg-muted)] mt-2">/ 100</div>
          {showGrade && (
            <div className="mt-2 font-heading font-extrabold" style={{ color }}>{grade}</div>
          )}
        </div>
      </div>
      <div className="mt-3 text-xs uppercase tracking-[0.2em] text-[var(--rg-muted)] font-bold">{label}</div>
    </div>
  );
};

export default ScoreGauge;
